/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState, useEffect } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import 'react-image-lightbox/style.css';
import { withTranslation } from 'react-i18next';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import {
  Button,
  ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem,
} from 'reactstrap';

import { get, post } from '../../helpers/api_helper';

function ListButton(props) {
  const { t, item } = props;

  toastr.options = {
    positionClass: 'toast-top-center',
    newestOnTop: true,
  };

  const [dropdown, setDropdown] = useState(false);
  const [lists, setLists] = useState([]);

  const getMyLists = async () => {
    try {
      const res = await get('/api/lists/mine');

      setLists(res);
    } catch (e) {
      toastr.error(t('Error loading user lists'));
    }
  };

  const addToDefaultList = async () => {
    try {
      const list = await post(`/api/lists/default/add/${item.id}`);
      toastr.success(t(`Item added to "${list.label}" list`));
    } catch (e) {
      toastr.error(t('Error adding item to list'));
    }
  };

  const addToCustomList = async (list) => {
    try {
      await post(`/api/lists/${list.id}/add/${item.id}`);
      toastr.success(t(`Item added to "${list.label}" list`));
    } catch (e) {
      toastr.error(t('Error adding item to list'));
    }
  };

  useEffect(() => {
    getMyLists();
  }, []);

  const jsx = (
    <div className="btn-group">
      <ButtonDropdown
        isOpen={dropdown}
        toggle={() => setDropdown(!dropdown)}
      >
        <Button id="caret" color="primary" className="btn-soft-primary" onClick={addToDefaultList}>
          <span className="mdi mdi-plus" />
          {' '}
          {t('Add to List')}
        </Button>
        <DropdownToggle caret color="primary" className="btn-soft-primary">
          <i className="mdi mdi-chevron-down" />
        </DropdownToggle>
        <DropdownMenu>
          {lists.length === 0 && (
            <DropdownItem href="#">{t('Default')}</DropdownItem>
          )}
          {lists.map((x) => (
            <DropdownItem key={x.id} href="#" onClick={() => { addToCustomList(x); }}>{x.label}</DropdownItem>
          ))}
        </DropdownMenu>
      </ButtonDropdown>
    </div>
  );

  return jsx;
}

ListButton.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  item: PropTypes.object.isRequired,
};

export default connect(() => ({

}), {})(withTranslation()(ListButton));
